module.exports = __webpack_public_path__ + "img/full4-min.292a57cb.png";